import React from 'react'
import { Helmet } from 'react-helmet'

export const NotFound = () => (
  <>
    <Helmet>
      <title>Not Found</title>
    </Helmet>
    <h2>Not Found</h2>
  </>
)
